import { Link } from "react-router-dom";
import { Gauge } from "lucide-react";
import { t } from "@/i18n";

export function GarageFlowLogo({ light = false, to = "/", testId = "garageflow-logo" }) {
  return (
    <Link to={to} data-testid={testId} className="inline-flex items-center gap-2.5">
      <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-teal-500 shadow-sm">
        <Gauge className="h-5 w-5 text-white" strokeWidth={2.4} />
      </span>
      <span className={`font-display text-xl font-extrabold tracking-tight ${light ? "text-white" : "text-[#0A2540]"}`}>
        {t("brand.name")}
      </span>
    </Link>
  );
}

export function PoweredBy() {
  return (
    <a href="/" data-testid="powered-by-garageflow" className="inline-flex items-center gap-1.5 text-xs text-slate-500 transition-colors duration-200 hover:text-slate-800">
      <Gauge className="h-3.5 w-3.5" /> {t("brand.poweredBy")}
    </a>
  );
}

export function AuthLayout({ title, subtitle, children, aside }) {
  return (
    <div className="grid min-h-screen lg:grid-cols-[1fr_1.1fr]">
      <div className="relative hidden flex-col justify-between overflow-hidden bg-[#0A2540] p-12 lg:flex">
        <div className="gf-grid-bg absolute inset-0 opacity-40 [filter:invert(1)]" />
        <div className="relative"><GarageFlowLogo light /></div>
        <div className="relative max-w-md">
          {aside || (
            <>
              <p className="font-display text-4xl font-extrabold leading-tight text-white">{t("auth.asideTitle")}</p>
              <p className="mt-4 text-slate-300">{t("auth.asideText")}</p>
            </>
          )}
        </div>
        <p className="relative text-xs text-slate-400">{t("brand.footer")}</p>
      </div>
      <div className="flex items-center justify-center bg-slate-50 px-5 py-12">
        <div className="w-full max-w-md gf-rise">
          <div className="mb-8 lg:hidden"><GarageFlowLogo /></div>
          <h1 className="text-3xl font-bold tracking-tight text-slate-900">{title}</h1>
          {subtitle && <p className="mt-2 text-sm text-slate-600">{subtitle}</p>}
          <div className="mt-8">{children}</div>
        </div>
      </div>
    </div>
  );
}
